import type { ReactNode } from "react"
import { Paper, Stack, styled } from "@mui/material"
import mobileMindLogo from "../img/logo.png"

const Logo = styled("img")({
  display: "block",
  width: 300,
  maxWidth: "100%",
})

const CardContent = styled("div")({
  width: "100%",
  textAlign: "left",
})

export interface LogoCardProps {
  children?: ReactNode
  className?: string
}

/** A shared MobileMind-branded card surface. */
export const LogoCard = styled(({ children, className }: LogoCardProps) => {
  return (
    <Paper className={className} elevation={0}>
      <Stack spacing={4} alignItems="center">
        <Logo src={mobileMindLogo} alt="MobileMind" />
        <CardContent>{children}</CardContent>
      </Stack>
    </Paper>
  )
})(({ theme }) => ({
  width: 600,
  maxWidth: "90vw",
  position: "relative",
  zIndex: 1,
  padding: theme.spacing(8),
  boxSizing: "border-box",
  borderRadius: 16,
  overflow: "hidden",
  textAlign: "center",
  backgroundColor: theme.palette.common.white,
  boxShadow: "0 2px 4px rgb(0 0 0 / 20%)",
  animation: "logoCardFadeInUp 1s",
  "@keyframes logoCardFadeInUp": {
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
  },
}))

export default LogoCard
